import { render } from "./BoxLayout.vue?vue&type=template&id=21f91874&scoped=true"
import script from "./BoxLayout.vue?vue&type=script&lang=js"
export * from "./BoxLayout.vue?vue&type=script&lang=js"

import "./BoxLayout.vue?vue&type=style&index=0&id=21f91874&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f91874"]])

export default __exports__